import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { BehaviorSubject, Subject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class MatterService {
  legalMatter: any;
  editLegalMatterSubject = new BehaviorSubject<any>(null);
  editLegalMatterObservable: Observable<any> = this.editLegalMatterSubject.asObservable();
  editGeneralMatterSubject = new BehaviorSubject<any>(null);
  editGeneralMatterObservable: Observable<any> = this.editGeneralMatterSubject.asObservable();
  private _legalMatter: any = null;


  constructor() {
  }
  
  // setMatter(data: any) {
  //   this.editLegalMatterSubject.next(data);
  // }
  editLegalMatter(legalMatter: any) {
    this.editLegalMatterSubject.next(legalMatter);
  }
  editGeneralMatter(generalMatter: any) {
    this.editGeneralMatterSubject.next(generalMatter);
  }
  setLegalMatter(data: any) {
    this._legalMatter = data;
    localStorage.setItem('legalMatterDraft', JSON.stringify(data)); // persist
  }

  getLegalMatter() {
    if (this._legalMatter) {
      return this._legalMatter;
    }

    const saved = localStorage.getItem('legalMatterDraft');
    if (saved) {
      this._legalMatter = JSON.parse(saved);
      return this._legalMatter;
    }

    return null;
  }

  clearLegalMatter() {
    this._legalMatter = null;
    localStorage.removeItem('legalMatterDraft');
  }
}